var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _EventEmitter = class {
  static getEventEmitter(target) {
    console.assert(target !== void 0 && target !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    if (target instanceof _EventEmitter) {
      return target;
    }
    return this.targetEmitterMap.get(target);
  }
  static getOrCreateEventEmitter(target) {
    let eventEmitter = this.getEventEmitter(target);
    if (!eventEmitter) {
      eventEmitter = new _EventEmitter(target);
    }
    return eventEmitter;
  }
  constructor(target) {
    if (target === void 0 || target === null) {
      target = this;
    }
    console.assert(!_EventEmitter.targetEmitterMap.has(target), `\u540C\u4E00\u4E2A ${target} \u5BF9\u8C61\u65E0\u6CD5\u5BF9\u5E94\u4E24\u4E2A EventEmitter\uFF01`);
    _EventEmitter.targetEmitterMap.set(target, this);
    _EventEmitter.emitterTargetMap.set(this, target);
  }
  eventNames() {
    const names = Object.keys(_EventEmitter.emitterListenerMap.get(this));
    return names;
  }
  listenerCount(type) {
    var _a, _b;
    return ((_b = (_a = _EventEmitter.emitterListenerMap.get(this)) == null ? void 0 : _a[type]) == null ? void 0 : _b.length) || 0;
  }
  once(type, listener, thisObject, priority = 0) {
    this.on(type, listener, thisObject, priority, true);
    return this;
  }
  emitEvent(event) {
    const currentTarget = _EventEmitter.emitterTargetMap.get(this);
    if (event.targets.indexOf(currentTarget) !== -1) {
      return event;
    }
    this.handleEvent(event);
    this.handelEventShare(event);
    this.handelEventBubbles(event);
    this.handelEventBroadcast(event);
    return event;
  }
  emit(type, data, bubbles = false, broadcast = false, share = true) {
    const event = {
      type,
      data,
      share,
      bubbles,
      broadcast,
      target: void 0,
      currentTarget: void 0,
      isStopShare: false,
      isStopBubbles: false,
      isStopBroadcast: false,
      isStopTransmit: false,
      isStop: false,
      targets: [],
      handles: []
    };
    this.emitEvent(event);
    return event;
  }
  broadcast(type, data) {
    return this.emit(type, data, false, true);
  }
  bubbles(type, data) {
    return this.emit(type, data, true, false);
  }
  has(type) {
    return this.listenerCount(type) > 0;
  }
  on(type, listener, thisObject, priority = 0, once = false) {
    if (listener === null)
      return this;
    let objectListener = _EventEmitter.emitterListenerMap.get(this);
    if (!objectListener) {
      objectListener = { __anyEventType__: [] };
      _EventEmitter.emitterListenerMap.set(this, objectListener);
    }
    thisObject = thisObject || this;
    const listeners = objectListener[type] = objectListener[type] || [];
    let i = 0;
    for (i = 0; i < listeners.length; i++) {
      const element = listeners[i];
      if (element.listener === listener && element.thisObject === thisObject) {
        listeners.splice(i, 1);
        break;
      }
    }
    listeners.push({ listener, thisObject, priority, once });
    return this;
  }
  off(type, listener, thisObject) {
    if (!type) {
      _EventEmitter.emitterListenerMap.delete(this);
      return this;
    }
    const objectListener = _EventEmitter.emitterListenerMap.get(this);
    if (!objectListener)
      return this;
    if (!listener) {
      delete objectListener[type];
      return this;
    }
    thisObject = thisObject || this;
    const listeners = objectListener[type];
    if (listeners) {
      for (let i = listeners.length - 1; i >= 0; i--) {
        const element = listeners[i];
        if (element.listener === listener && element.thisObject === thisObject) {
          listeners.splice(i, 1);
          break;
        }
      }
      if (listeners.length === 0) {
        delete objectListener[type];
      }
    }
    return this;
  }
  offAll(type) {
    this.off(type);
    return this;
  }
  onAny(listener, thisObject, priority = 0, once = false) {
    let objectListener = _EventEmitter.emitterListenerMap.get(this);
    if (!objectListener) {
      objectListener = { __anyEventType__: [] };
      _EventEmitter.emitterListenerMap.set(this, objectListener);
    }
    const listeners = objectListener.__anyEventType__;
    let i = 0;
    for (i = 0; i < listeners.length; i++) {
      const element = listeners[i];
      if (element.listener === listener && element.thisObject === thisObject) {
        listeners.splice(i, 1);
        break;
      }
    }
    listeners.push({ listener, thisObject, priority, once });
    return this;
  }
  offAny(listener, thisObject) {
    const objectListener = _EventEmitter.emitterListenerMap.get(this);
    if (!listener) {
      if (objectListener) {
        objectListener.__anyEventType__.length = 0;
      }
      return;
    }
    if (objectListener) {
      const listeners = objectListener.__anyEventType__;
      for (let i = listeners.length - 1; i >= 0; i--) {
        const element = listeners[i];
        if (element.listener === listener && element.thisObject === thisObject) {
          listeners.splice(i, 1);
          break;
        }
      }
    }
    return this;
  }
  handleEvent(e) {
    const eventTarget = _EventEmitter.emitterTargetMap.get(this);
    e.target = e.target || eventTarget;
    e.currentTarget = eventTarget;
    e.targets.push(eventTarget);
    const objectListener = _EventEmitter.emitterListenerMap.get(this);
    if (!objectListener)
      return;
    let listeners = objectListener[e.type];
    const callListeners = [];
    if (listeners) {
      listeners.forEach((v) => callListeners.push(v));
      for (let i = listeners.length - 1; i >= 0; i--) {
        if (listeners[i].once) {
          listeners.splice(i, 1);
        }
      }
      if (listeners.length === 0) {
        delete objectListener[e.type];
      }
    }
    listeners = objectListener.__anyEventType__;
    if (listeners) {
      listeners.forEach((v) => callListeners.push(v));
      for (let i = listeners.length - 1; i >= 0; i--) {
        if (listeners[i].once) {
          listeners.splice(i, 1);
        }
      }
    }
    callListeners.sort((a, b) => b.priority - a.priority);
    for (let i = 0; i < callListeners.length && !e.isStop; i++) {
      callListeners[i].listener.call(callListeners[i].thisObject, e);
      e.handles.push(callListeners[i]);
    }
  }
  handelEventShare(event) {
    if (!event.share || event.isStopShare || event.isStop || event.isStopTransmit)
      return;
    const eventTarget = _EventEmitter.emitterTargetMap.get(this);
    if (typeof (eventTarget == null ? void 0 : eventTarget.getShareTargets) === "function") {
      const bubbleTargets = eventTarget.getShareTargets();
      bubbleTargets == null ? void 0 : bubbleTargets.forEach((v) => {
        if (v === void 0 || v === null)
          return;
        const eventEmitter = _EventEmitter.getOrCreateEventEmitter(v);
        eventEmitter.emitEvent(event);
      });
    }
  }
  handelEventBubbles(event) {
    if (!event.bubbles || event.isStopBubbles || event.isStop || event.isStopTransmit)
      return;
    const eventTarget = _EventEmitter.emitterTargetMap.get(this);
    let bubbleTargets = [];
    if (typeof (eventTarget == null ? void 0 : eventTarget.getBubbleTargets) === "function") {
      bubbleTargets = eventTarget.getBubbleTargets();
    } else if (eventTarget["parent"]) {
      bubbleTargets = [eventTarget["parent"]];
    }
    bubbleTargets == null ? void 0 : bubbleTargets.forEach((v) => {
      if (v === void 0 || v === null)
        return;
      if (event.targets.indexOf(v) !== -1)
        return;
      const eventEmitter = _EventEmitter.getOrCreateEventEmitter(v);
      eventEmitter.emitEvent(event);
    });
  }
  handelEventBroadcast(event) {
    if (!event.broadcast || event.isStopBroadcast || event.isStop || event.isStopTransmit)
      return;
    const eventTarget = _EventEmitter.emitterTargetMap.get(this);
    let broadcastTargets = [];
    if (typeof (eventTarget == null ? void 0 : eventTarget.getBroadcastTargets) === "function") {
      broadcastTargets = eventTarget.getBroadcastTargets();
    } else if (eventTarget["children"] && Array.isArray(eventTarget["children"])) {
      broadcastTargets = eventTarget["children"];
    }
    broadcastTargets == null ? void 0 : broadcastTargets.forEach((v) => {
      if (v === void 0 || v === null)
        return;
      if (event.targets.indexOf(v) !== -1)
        return;
      const eventEmitter = _EventEmitter.getOrCreateEventEmitter(v);
      eventEmitter.emitEvent(event);
    });
  }
  dispose() {
    this.offAll();
  }
};
let EventEmitter = _EventEmitter;
__publicField(EventEmitter, "targetEmitterMap", /* @__PURE__ */ new Map());
__publicField(EventEmitter, "emitterTargetMap", /* @__PURE__ */ new Map());
__publicField(EventEmitter, "emitterListenerMap", /* @__PURE__ */ new Map());
class AnyEmitter {
  eventNames(obj) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    const names = ((_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.eventNames()) || [];
    return names;
  }
  listenerCount(obj, type) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    const count = ((_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.listenerCount(type)) || 0;
    return count;
  }
  once(obj, type, listener, thisObject = null, priority = 0) {
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    EventEmitter.getOrCreateEventEmitter(obj).once(type, listener, thisObject, priority);
    return this;
  }
  emitEvent(obj, event) {
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    EventEmitter.getOrCreateEventEmitter(obj).emitEvent(event);
    return event;
  }
  emit(obj, type, data, bubbles = false, broadcast = false, share = true) {
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    const event = EventEmitter.getOrCreateEventEmitter(obj).emit(type, data, bubbles, broadcast, share);
    return event;
  }
  has(obj, type) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    const result = ((_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.has(type)) || false;
    return result;
  }
  on(obj, type, listener, thisObject, priority = 0, once = false) {
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    EventEmitter.getOrCreateEventEmitter(obj).on(type, listener, thisObject, priority, once);
    return this;
  }
  off(obj, type, listener, thisObject) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    (_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.off(type, listener, thisObject);
    return this;
  }
  offAll(obj, type) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    (_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.offAll(type);
    return this;
  }
  onAny(obj, listener, thisObject, priority = 0, once = false) {
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    EventEmitter.getOrCreateEventEmitter(obj).onAny(listener, thisObject, priority, once);
    return this;
  }
  offAny(obj, listener, thisObject) {
    var _a;
    console.assert(obj !== void 0 && obj !== null, `\u88AB\u76D1\u542C\u5BF9\u8C61\u65E0\u6CD5\u4E3Aundefined\u6216\u8005null\uFF01`);
    (_a = EventEmitter.getEventEmitter(obj)) == null ? void 0 : _a.offAny(listener, thisObject);
    return this;
  }
}
const anyEmitter = new AnyEmitter();
const globalEmitter = new EventEmitter();
const objectEmitter = anyEmitter;
export {
  AnyEmitter,
  EventEmitter,
  anyEmitter,
  globalEmitter,
  objectEmitter
};
//# sourceMappingURL=index.js.map
